export const initDummyData = () => {
  const regionsData = {
    grandMassif: {
      name: 'Grand Massif',
      url: '/gm',
      children: [
        {
          name: 'Val Thorens',
          url: '/gm/vt'
        },
        {
          name: 'Les Menuires',
          url: '/gm/lm'
        },
        {
          name: 'Courchevel',
          url: '/gm/co'
        }
      ]
    },
    oisans: {
      name: 'Oisans',
      url: '/o',
      children: [
        {
          name: 'Montgenevre',
          url: '/o/mo'
        },
        {
          name: 'Serre Chevalier',
          url: '/o/sc'
        },
        {
          name: 'Briancon',
          url: '/o/br'
        }
      ]
    }
  };
  return regionsData;
};
